import React from 'react'
import { Link} from 'react-router-dom';

const ThreeSection = ({sections}) => {
  
    return (
      <div className="three-section-container">
        {sections.map((section, index) => (
          <div key={index} className="section">
            <img src={section.image} alt={section.title} className="section-image" />
            <h2 className="section-title">{section.title}</h2>
            <p className="section-description">{section.description}</p>
            <div className="buttons-container">
              {section.buttons.map((buttonText, idx) => (
                 <Link to={buttonText.url}>
                <button key={idx} className="section-button">{buttonText.text}</button>
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  };

export default ThreeSection